import { useAuthContext } from '../contexts/AuthContext'

/**
 * Hook for accessing authentication state and methods.
 * 
 * @example
 * const { user, signInWithOtp, signOut, isLoading } = useAuth()
 */
export function useAuth() {
  return useAuthContext()
}
